/**
 * Disposable interface.
 *
 * @public
 * {@docCategory IDisposable}
 */
export interface IDisposable {
  dispose: () => void;
}
